package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SyndromeIndicationSignSymptomSeverity(private val literal: String) : IEnumType {
	不限("不限"),
	轻("轻"),
	中("中"),
	重("重");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "syndrome_indication_sign_symptom_severity"}
	override fun getLiteral(): String {return literal}
}
